import RangeSlider, { ABTestingLabel } from '@upsales/components/RangeSlider';

window.RangeSlider = RangeSlider;
window.ABTestingLabel = ABTestingLabel;
